import axios from '@/plugins/axios';
import { routerList } from '@/utils/auth';
import { waterMark } from '@/plugins/waterMark';
import log from '@/plugins/log';
import { isIP } from '@2/utils';

const user = {
    state: {
        menus: [], // 菜单列表
        keepList: [], // 缓存的页面
        dictMap: {}, // 字典
        depList: [], // 组织架构
        userInfo: null
    },
    mutations: {
        SET_KEEPLIST: (state, list) => {
            state.keepList = list;
        },
        SET_USERINFO: (state, info) => {
            state.userInfo = info;
        },
        SET_MENUS: (state, menus = []) => {
            const list = menus?.filter(it => routerList.map(li => li.name).includes(it.name));
            const menuList = [];
            list.map(it => {
                const info = it.data;
                if (it.children) {
                    info.children = it.children;
                }
                menuList.push(info);
            });
            state.menus = menuList;
        },
        SET_DICTMAP: (state, list) => {
            state.dictMap = list;
        }
    },
    actions: {
        // 获取用户信息
        GetInfo({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                axios({
                    url: '/user-control/v1/userInfo',
                    method: 'get'
                }).then(res => {
                    resolve(res.data);
                    const user = res.data?.user || {};
                    commit('SET_USERINFO', {
                        ...res.data.user,
                        isNewVersion: res.data.isNewVersion,
                        userRole: res.data.role
                    });
                    commit('SET_MENUS', res?.data?.menus);
                    waterMark({
                        content: user?.nickName + user?.empNo,
                        fontSize: '12px'
                    });

                    if (['0332040', '0149252'].includes(user?.empNo)) {
                        localStorage.setItem('vconsoleBtn', true);
                    }

                    window.userInfo = {
                        ...user,
                        isSuperAdmin: res.data.isSuperAdmin,
                        userRole: res.data.role
                    };
                    log.logConfig(window.userInfo);
                }).catch(error => {
                    reject(error);
                });
                axios({
                    url: '/custom/field/query',
                    method: 'get'
                }).then(res => {
                    commit('SET_DICTMAP', res.data);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        addOneKeepList({ commit, state }, name) {
            const keepList = [...state.keepList];
            if (!keepList.includes(name)) {
                keepList.push(name);
            }
            commit('SET_KEEPLIST', keepList);
        },
        delOneKeepList({ commit, state }, name) {
            const keepList = [...state.keepList];
            if (keepList.indexOf(name) > -1) {
                const index = keepList.indexOf(name);
                keepList.splice(index, 1);
            }
            commit('SET_KEEPLIST', keepList);
        },
        // 登录
        LogIn({ commit }) {
            return new Promise((resolve, reject) => {
                // 跳用户中心
                localStorage.clear();
                const address = import.meta.env.VITE_OOS_ADDRESS;
                const appkey = import.meta.env.VITE_APP_USER_KEY;
                const url = window.location.pathname + window.location.hash;
                const redirect_url = `${window.location.origin}/indexV2/loginHome?url=${url}`;
                console.log(`${address}?redirectUrl=${redirect_url}&appKey=${appkey}`);
                window.top.location.href = `${address}?redirectUrl=${redirect_url}&appKey=${appkey}`;
                // 跳中台方式
                // localStorage.clear();
                // const host = import.meta.env.VITE_APP_LOGIN_URL;
                // const tenantCode = import.meta.env.VITE_TENANT_CODE;
                // const url = window.location.pathname + window.location.hash;
                // const redirect_url = btoa(`${window.location.origin}/loginHome?url=${url}`);
                // window.top.location.href = `${host}/auth/api/login/tenant?redirectUrl=${redirect_url}&tenantCode=${tenantCode}`;
            });
        },
        // 登出
        LogOut({ commit }) {
            return new Promise((resolve, reject) => {
                axios({
                    url: `/login/out?token=${localStorage.getItem('authToken')}`,
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                        'ticket': localStorage.getItem('ticket')
                    }
                }).then(res => {
                    localStorage.clear();
                    this.dispatch('LogIn');
                }).catch(error => {
                    reject(error);
                });
                // window.top.location.href = `http://geely-uc-sso-protocol-restful-sit.sgw.test.geely.svc/invalidate/${window.userInfo.ticket}`;
            });
        }
    }
};

export default user;
